import { z } from "zod";

const actividadArchivoMetaSchema = z.object({
  llave: z.string(),
  nombre: z.string(),
  url: z.string().url().optional(),
});

const archivoAdjuntoOpcional = z
  .union([actividadArchivoMetaSchema, z.null(), z.undefined()])
  .optional();

export const createActividadProgramaSchema = z.object({
  idPrograma: z.number().int().positive(),
  nombre: z.string().min(1),
  rol: z.string().optional(),
  archivoLimpio: archivoAdjuntoOpcional,
  archivoWord: archivoAdjuntoOpcional,
  fechaInicio: z.coerce.date().nullable().optional(),
  fechaFin: z.coerce.date().nullable().optional(),
});

export type CreateActividadProgramaInput = z.infer<
  typeof createActividadProgramaSchema
>;
